import React, { useState, useContext, useMemo } from 'react'
import { connect } from 'react-redux'
// import { getReportNameMap } from 'api/pgads'
import {
  getUserReport,
  getApiTargetInfo,
  getReportNameMap,
  getUserInfo,
  getClientInfo,
  isValidYearRange,
  getValidYearRange,
} from 'core'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import {
  Select,
  DatePicker,
  Button,
  Table,
  message,
  Popconfirm,
  Modal,
} from 'antd'
import moment from 'moment'
import { getCompletedReport, reportCleanFiles } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { downloadFile } from './dm/reportCall'
import R from 'ramda'
import {
  AEPREG_CLIENT,
  AEPUNREG_CLIENT,
  APS_CLIENT,
  DOM_CLIENT,
  KINDLE_CLIENT,
  NRG_CLIENT,
  SRP_CLIENT,
  WEE_CLIENT,
} from 'client'
const convertReportName = (rptNames, fileName) => {
  const cf = fileName.split('_').join(' ')
  const spfn = cf.split(' ')
  const fnname = spfn.map((t, i) => {
    return R.range(0, i + 1)
      .map(e => spfn[e])
      .reduce((a, b) => a + ' ' + b)
  })

  const rptnameLowerCase = rptNames
    .filter(r => r !== undefined)
    .map(r => r.toLowerCase())
  const found = fnname
    .filter(r => r !== undefined)
    .filter(f => rptnameLowerCase.includes(f.toLowerCase()))[0]
  return (
    found || fileName || ''
    // .filter(r => r !== undefined)
  )

  // text
  // .substr(0, text.indexOf(userInfo.userName) - 1)
  // .split('_')
  // .join(' ')
}
const columns = (download, setShowError) => [
  // {
  //   title: 'Report Name',
  //   dataIndex: 'fileName',
  //   key: 'name',
  // },
  {
    title: 'Report Name',
    // dataIndex: 'fileName',
    dataIndex: 'fileNameOnly',
    key: 'fileNameOnly',
    width: 400,
    defaultSortOrder: 'ascend',
    sortDirections: ['ascend', 'descend'],
    // sorter: (a, b) => a.fileNameOnly < b.fileNameOnly,
    // multiple: 1,

    // render: (text, record, index) => convertReportName(rptNames, text),
    // text.indexOf('ADHOC') < 0 ? convertReportName(rptNames, text) : text,
    // render: (text, record, index) =>
    //   text.indexOf('ADHOC') < 0
    //     ? text
    //         .substr(0, text.indexOf(userInfo.userName) - 1)
    //         .split('_')
    //         .join(' ')
    //     : text,
  },
  {
    title: 'Size',
    dataIndex: 'dataSize',
    key: 'dataSize',
    width: 100,
    defaultSortOrder: 'descend',
    sortDirections: ['descend', 'ascend'],
    // sorter: (a, b) => a.dataSize < b.dataSize,
    // multiple: 1,
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: 100,
  },

  {
    title: 'Last Modified Date',
    // dataIndex: 'time',
    // key: 'time',
    // render: (text, record, index) => moment(text).format('MM/DD/YYYY HH:mm:ss'),
    key: 'timeMomentText',
    dataIndex: 'timeMomentText',
    width: 200,
    sortOrder: 'descend',
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId',
    width: 200,
  },
  {
    title: 'Action',
    dataIndex: 'fileName',
    key: 'x',
    render: (text, record) => {
      if (record.comments && record.comments.startsWith('Error'))
        return (
          <a
            onClick={_ => {
              setShowError(record.comments)
            }}
          >
            Show Error
          </a>
        )
      else return <a onClick={_ => download(text)}>Download</a>
    },
    width: 100,
  },
]
// .map(c => ({ ...c, title: <div style={{ backgroundColor: '#eee' }}>{c.title}</div> }))

const CompletedReports = ({
  reportNameMap,
  targetInfo,
  userReportsPermits,
  CLIENT,
  validYearRange,
  // userInfo,
}) => {
  const [reportName, setReportName] = useState(['All'])
  const [data, setData] = useState([])
  const [showError, setShowError] = useState()
  const [selectedDate, setSelectedDate] = useState([
    moment().startOf('month'),
    moment().endOf('month'),
  ])
  const { setError } = useContext(ErrorContext)

  const isMarginReport = [
    KINDLE_CLIENT,
    APS_CLIENT,
    WEE_CLIENT,
    DOM_CLIENT,
    SRP_CLIENT,
    WEE_CLIENT,
    AEPREG_CLIENT,
    AEPUNREG_CLIENT,
  ]

  const rptNames = [
    'ADHOC',
    ...userReportsPermits.map(i => reportNameMap[i]),
    isMarginReport.includes(CLIENT) ? 'MA EVENT PLANNER' : undefined,
  ]
    .filter(f => !!f)
    .sort()

  const { setSpinning } = useContext(SpinContext)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const download = fileName => downloadFile(targetInfo)(fileName)

  const retrieveData = _ => {
    if (reportName.length <= 0) {
      message.error('Please, Select Report(s) ')
      return
    }
    const isValid = isValidYearRange(
      validYearRange,
      selectedDate[0],
      selectedDate[1]
    )
    if (!isValid) return
    setSpinning(true)
    getCompletedReport(targetInfo)({
      startDate: selectedDate[0].format('YYYY-MM-DD'),
      endDate: selectedDate[1].format('YYYY-MM-DD'),
      reportName: reportName.includes('All') ? rptNames : reportName,
    }).fork(setError, data => {
      const orig = data
        .map(d => ({
          ...d,
          timeMoment: moment(d.time),
          timeMomentText: moment(d.time).format('MM/DD/YYYY HH:mm:ss'),
          fileNameOnly: convertReportName(rptNames, d.fileName),
        }))
        .sort((a, b) => b.timeMoment - a.timeMoment)

      // if (isMarginReport) orig.push({ reportName: 'MA_EVENT_PLANNER' })

      setData(orig)
      setSpinning(false)
    })
  }

  const cleanUpFiles = _ => {
    setSpinning(true)
    reportCleanFiles(targetInfo).fork(setError, _ => {
      setSpinning(false)
      retrieveData()
    })
  }

  const headers = useMemo(
    _ => {
      const hr = columns(download, setShowError)
      const Extra = {
        title: 'Type',
        dataIndex: 'comments',
        key: 'comments',
        width: 100,
      }
      if (CLIENT === NRG_CLIENT) return [...hr, Extra]
      return hr
    },
    [CLIENT, download]
  )

  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Completed Reports
        </Title>
        {/* <DatePicker.RangePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
          onPanelChange={d => {
            setSelectedDate(d)
          }}
        /> */}

        <DatePicker
          value={selectedDate[0]}
          format="MM/DD/YYYY"
          onChange={date => {
            const endDate = date.isAfter(selectedDate[1])
              ? date
              : selectedDate[1]
            const range = [date, endDate]
            setSelectedDate(range)
          }}
          allowClear={false}
        />
        <div
          style={{
            marginLeft: '5px',
            marginRight: '5px',
            display: 'grid',
            alignItems: 'center',
          }}
        >
          To
        </div>
        <DatePicker
          value={selectedDate[1]}
          format="MM/DD/YYYY"
          onChange={date => {
            const stDate = date.isBefore(selectedDate[0])
              ? date
              : selectedDate[0]
            const range = [stDate, date]
            setSelectedDate(range)
          }}
          allowClear={false}
        />
        <Button
          icon="database"
          type="primary"
          style={{ marginLeft: '15px' }}
          onClick={retrieveData}
        >
          Retrieve
        </Button>
        <Filler />
        <Popconfirm
          title="Are you sure to delete reports ?"
          onConfirm={cleanUpFiles}
          okText="Yes"
          cancelText="No"
          placement="leftTop"
        >
          <Button icon="delete" type="danger">
            Delete Reports
          </Button>
        </Popconfirm>
      </CriteriaRow>
      <CriteriaRow style={{ padding: '10px' }}>
        <Select
          onChange={value => setReportName(value)}
          style={{ width: '100%', marginLeft: '15px' }}
          value={reportName}
          mode="multiple"
          placeholder="Select Reports"
        >
          <Select.Option value="All">All</Select.Option>
          {rptNames.map(r => (
            <Select.Option key={r} value={r}>
              {r}
            </Select.Option>
          ))}
        </Select>
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height }) => (
          <Content
            style={{ height: height - 20, paddingTop: '0px', padding: '10px' }}
          >
            <div style={{}}>
              <Table
                dataSource={data}
                columns={headers}
                pagination={false}
                size="small"
                scroll={{ y: height - 100 }}
                rowKey="fileName"
                onChange={_ => _}
              />
            </div>
          </Content>
        )}
      </FullHeightSizer>
      {showError && (
        <Modal
          title="Error"
          visible={showError !== undefined}
          width={700}
          height={500}
          onCancel={_ => setShowError()}
          footer={null}
          bodyStyle={{
            display: 'grid',
            gridTemplateRows: '10fr 2fr',
            gridGap: '10px',
          }}
        >
          <div style={{ overflow: 'auto', backgroundColor: 'antiquewhite' }}>
            {showError}
          </div>
          <div style={{ flexDirection: 'row-reverse', display: 'flex' }}>
            <Button type="primary" onClick={_ => setShowError()}>
              OK
            </Button>
          </div>
        </Modal>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  userReportsPermits: getUserReport(state),
  reportNameMap: getReportNameMap(state),
  targetInfo: getApiTargetInfo(state),
  userInfo: getUserInfo(state),
  CLIENT: getClientInfo(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(CompletedReports)
